import { Components } from '@mui/material/styles';
import { Theme } from '@mui/material';

export const flowAccordionActions: Components<Theme>['MuiAccordionActions'] = {
  defaultProps: {
    // we are using our own flex gap
    disableSpacing: true,
  },
  styleOverrides: {
    root: {
      // change align from right to left
      justifyContent: 'flex-start',
      // flex-gap between multiple buttons
      gap: '8px',
      // proportions
      padding: '22px 0',
    },
  },
};
